import React, { Component } from "react";
import { connect } from "react-redux";
import "./TableEditReceivables.css";
import { withRouter } from "react-router-dom";
import Anchor from "./Anchor";

const initialState = {
    divScroll: null
}

class TableEditReceivables extends Component
{
    state = {...initialState}

    componentDidMount = async () =>
    {
        let divScroll = this.divScroll;

        await this.setState({ divScroll });
    }

    onScroll = async () =>
    {
        if (this.state.divScroll.scrollHeight - Math.ceil(this.state.divScroll.scrollTop) === this.state.divScroll.clientHeight) { this.props.onScroll(); }
    }

    formatCurrency = (value) =>
    {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(value);
    }

    formatDate = (dateString) =>
    {
        const date = new Date(dateString);
        return date.toLocaleDateString('pt-BR');
    }

    render ()
    {
        return (
            <div 
                className="tableEditAdvancedBusiness" 
                onScroll={this.onScroll} 
                ref={divScroll => this.divScroll = divScroll}
            >
                <table className="table">
                    <thead>
                        <tr className="theadTableEditAdvancedBusiness">
                            <td
                                className={`minimus60 center ${this.props.columns?.find(c => c.slug === "ID_SERVICE" && !c.visible) ? "d-none" : ""}`}
                                title="ID"
                            >
                                ID
                            </td>
                            <td
                                className={`minimus60 center ${this.props.columns?.find(c => c.slug === "OFFICE" && !c.visible) ? "d-none" : ""}`}
                                title="UNIDADE"
                            >
                                Unidade
                            </td>
                            <td
                                className={`minimus120 center ${this.props.columns?.find(c => c.slug === "CLIENT_NAME" && !c.visible) ? "d-none" : ""}`}
                                title="Nome do Cliente"
                            >
                                Nome
                            </td>
                            <td
                                className={`minimus120 center ${this.props.columns?.find(c => c.slug === "DEBT_VALUE" && !c.visible) ? "d-none" : ""}`}
                                title="Valor da Dívida"
                            >
                                VALOR
                            </td>
                            <td
                                className={`minimus60 center ${this.props.columns?.find(c => c.slug === "DEBT_NUMBER" && !c.visible) ? "d-none" : ""}`}
                                title="Número da Parcela"
                            >
                                Nº PARCELA
                            </td>
                            <td
                                className={`minimus120 center ${this.props.columns?.find(c => c.slug === "DUE_DATE" && !c.visible) ? "d-none" : ""}`}
                                title="DATA DA VENCIMENTO"
                            >
                                DATA DA VENCIMENTO
                            </td>
                            <td
                                className={`minimus120 center ${this.props.columns?.find(c => c.slug === "TYPE_SERVICE" && !c.visible) ? "d-none" : ""}`}
                                title="Tipo de Serviço"
                            >
                                TIPO DE SERVIÇO
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.props.data?.map((e, i) => {
                                return (
                                    <tr key={`${i}`} className="tbodyTableEditAdvancedBusiness">
                                        <td
                                            className={`center ${this.props.columns?.find(c => c.slug === "ID_SERVICE" && !c.visible) ? "d-none" : ""}`}
                                            title={e.idService}
                                        >
                                            <Anchor
                                                classaditional="anchorOpenBusinessInNewWindow" 
                                                onClick={() => {
                                                    // window.open(`/service/details/${e.idService}`);
                                                }}
                                            >
                                                {e.idService}
                                            </Anchor>
                                        </td>
                                        <td
                                            className={`center ${this.props.columns?.find(c => c.slug === "OFFICE" && !c.visible) ? "d-none" : ""}`}
                                            title={e.office}
                                        >
                                            {e.office}
                                        </td>
                                        <td
                                            className={`center ${this.props.columns?.find(c => c.slug === "CLIENT_NAME" && !c.visible) ? "d-none" : ""}`}
                                            title={e.clientName}
                                        >
                                            {e.clientName}
                                        </td>
                                        <td
                                            className={`center ${this.props.columns?.find(c => c.slug === "DEBT_VALUE" && !c.visible) ? "d-none" : ""}`}
                                            title={this.formatCurrency(e.debtValue)}
                                        >
                                            {this.formatCurrency(e.debtValue)}
                                        </td>
                                        <td
                                            className={`center ${this.props.columns?.find(c => c.slug === "DEBT_NUMBER" && !c.visible) ? "d-none" : ""}`}
                                            title={e.debtNumber}
                                        >
                                            {e.debtNumber}
                                        </td>
                                        <td
                                            className={`center ${this.props.columns?.find(c => c.slug === "DUE_DATE" && !c.visible) ? "d-none" : ""}`}
                                            title={this.formatDate(e.dueDate)}
                                        >
                                            {this.formatDate(e.dueDate)}
                                        </td>
                                        <td
                                            className={`center ${this.props.columns?.find(c => c.slug === "TYPE_SERVICE" && !c.visible) ? "d-none" : ""}`}
                                            title={this.formatDate(e.typeService)}
                                        >
                                            {e.typeService}
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        )
    }
}

export default withRouter(connect(null, null)(TableEditReceivables));